<template>
  <section class="relative overflow-hidden md:pb-8">
    <!-- Purple background shape -->
    <div class="absolute bottom-12 -z-10 h-87.5 w-182.5 sm:bottom-0 md:h-95 lg:right-0 lg:bottom-auto lg:mt-36">
      <img
        src="https://images.rafflebox.ca/RaffleboxLogos/WebsiteAssets/case-study-bg-shape.svg"
        alt=""
        class="absolute -top-40 -left-37.5 rotate-40 sm:-left-12.5 sm:rotate-48 md:-top-23.5 md:left-0 md:rotate-51 lg:top-0 lg:rotate-0"
      />
    </div>
    <!-- Text and image section -->
    <div
      class="flex max-w-screen flex-col-reverse gap-10 px-3 pt-10 pb-6 md:pt-10 lg:mx-auto lg:flex-row lg:px-6 lg:py-24"
    >
      <!-- Text content -->
      <div class="flex w-full flex-col gap-24 px-5 md:gap-20 md:px-3 lg:max-w-xl lg:gap-10">
        <h4 class="mb-2 font-bold text-slate-800">
          {{ t('HomeCaseStudies.heading') }}
        </h4>
        <div class="mb-14 max-w-100 md:mb-0 lg:max-w-full">
          <!-- Green divider for desktop -->
          <hr class="text-rbgreen-200 mb-4 hidden h-0.5 w-12 lg:block" />

          <p class="font-family-display lg:text-rbgreen-400 mb-2 text-2xl text-white">
            {{ t('HomeCaseStudies.quote') }}
          </p>
          <p class="text-lg text-white lg:text-black">{{ t('HomeCaseStudies.quoteAuthor') }}</p>
          <p class="mb-4 text-lg text-white lg:text-black">
            <em>{{ t('HomeCaseStudies.quoteRole') }}</em>
          </p>
          <NuxtLink :to="localePath({ name: 'case-studies' })" class="text-lg text-white underline lg:text-[#4433ff]">{{
            t('HomeCaseStudies.cta')
          }}</NuxtLink>
        </div>
      </div>
      <!-- Image content -->
      <div class="w-full lg:pr-3">
        <img
          :src="renderImage('RaffleboxLogos/WebsiteAssets/firefighters-case-study.png', { width: 627 })"
          :alt="t('HomeCaseStudies.imageAlt')"
          class="w-full lg:rounded-xl"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import renderImage from '~/utils/render-image';

const localePath = useLocalePath();
const { t } = useI18n();
</script>
